import { Buffer }      from 'buffer';
import {
    DOWNLOAD_RESULT_PDF_FILE_REQUEST,
    downloadResultPdfFileSuccess,
    downloadResultPdfFileFailure,
} from 'Redux/Action';
import { ofType }      from 'redux-observable';
import { from, of, catchError, EMPTY } from 'rxjs';
import { mergeMap }    from 'rxjs/operators';
import { saveAs }      from 'file-saver';

export function downloadResultPdfFileEpic(action$, store$, { ResultRepository }) {
    return action$.pipe(
        ofType(DOWNLOAD_RESULT_PDF_FILE_REQUEST),
        mergeMap(action => {
            const { id } = action.payload;

            if (!`${id}`.trim()) {
                return EMPTY;
            }

            return from(ResultRepository.downloadPdfFile(id)).pipe(
                mergeMap(({ file, fileName }) => {
                  // if(file && fileName) {
                  //   saveAs(new Blob([ new Buffer(file, 'binary') ]), fileName);
                  // }
                  return from([
                      downloadResultPdfFileSuccess(),
                  ]);
                }),
                catchError(error => of(downloadResultPdfFileFailure(error))),
            );
        }),
    );
}
